import React from "react";
import { LuLoader2 } from "react-icons/lu";

import { cn } from "~/utils/fontsConfig";
import Modal from "~/components/v3/themed/Modal";
import { Button } from "../themed/Button";
import { CustomizableLayout } from "~/types/CustomizableLayout";

export const ConfirmActionModal = ({
    isOpen,
    onClose,
    Icon,
    title,
    description,
    onConfirm,
    confirmText,
    isLoading,
    variant,
    btnConfirmClassName,
    customization,
}: {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => void | Promise<void>;
    confirmText: string;
    Icon?: React.ReactNode;
    title?: string;
    description?: string;
    isLoading?: boolean;
    variant?: "default" | "destructive";
    btnConfirmClassName?: string;
    customization?: CustomizableLayout;
}) => {
    const handleConfirm = async () => {
        try {
            await onConfirm();
            onClose();
        } catch (error) {
            console.error("Error during confirmation:", error);
        }
    };

    return (
        <Modal
            open={isOpen}
            onOpenChange={onClose}
            title={title}
            description={description}
            icon={Icon}
            customization={customization}
            className="w-full max-w-[200px]"
            footer={
                <div className="flex w-full items-center justify-between gap-3 font-semibold">
                    <Button
                        variant="secondary"
                        className={customization?.buttons?.secondary}
                        onClick={onClose}
                        disabled={isLoading}
                    >
                        Cancel
                    </Button>

                    <Button
                        variant={variant}
                        onClick={handleConfirm}
                        disabled={isLoading}
                        className={cn(
                            btnConfirmClassName,
                            customization?.buttons?.default,
                        )}
                    >
                        {isLoading ? (
                            <LuLoader2 className="h-4 w-4 animate-spin" />
                        ) : (
                            confirmText
                        )}
                    </Button>
                </div>
            }
        ></Modal>
    );
};
